import React, { useState, useEffect } from "react";

import * as S from "./styles";

const SwitchTheme = () => {
  const [theme, setTheme] = useState(null);

  const isDarkMode = theme === "dark";

  const handleChangeTheme = () => {
    window.__setPreferredTheme(isDarkMode ? "light" : "dark");
  };

  useEffect(() => {
    setTheme(window.__theme);
    window.__onThemeChange = () => setTheme(window.__theme);
  }, []);

  return (
    <S.Wrapper id="switch" className="switch">
      <S.InputCheckBox
        type="checkbox"
        checked={!isDarkMode}
        onChange={handleChangeTheme}
        id="slider"
      />
      <S.Slider className="slider" round></S.Slider>
    </S.Wrapper>
  );
};

export default SwitchTheme;
